import template from './report_sick_leave_cycles.html';
import * as Permissions from '../../lib/permission_utils.js';
import * as Utils from '../../lib/savanna_utils.js';
import tr from '../../lib/default-translator.js';

class ReportSickLeaveCyclesViewModel
{
	constructor (page)
	{
		this.page = page;
		this.loader = ko.observable(false);

		this.current_department_id = ko.observable();
		this.selected_department = ko.observable();

		this.categories = ko.observableArray();
		this.selected_category = ko.observable();

		this.leave_taken_full = ko.observableArray('');
		this.cycle_current_date = ko.observable(null);


		this.selected_department.subscribe((newValue) => {
			if (newValue != null)
			{
				this.current_department_id(newValue.department_id);
				this.page.updateData();
			}
			else
			{
				this.current_department_id(null);
				this.page.updateData();
			}
		});

		this.selected_category.subscribe((newText) => {
			this.page.updateData();
		});
	}

	async download_clicked(v, e)
	{
		let csv_string = await Utils.table_to_csv(document.getElementById('leave_taken_report'));
		if (csv_string === null || csv_string === undefined || csv_string === '')
			return;

		let blob = new Blob([csv_string], { type: 'text/csv;charset=utf-8;' });
		let link = document.createElement('a');

		link.href = URL.createObjectURL(blob);
		link.setAttribute('download', 'leave_taken_report.csv');

		document.body.appendChild(link);
		link.click();
		document.body.removeChild(link);
	}

	show_report_help()
	{
		Grape.dialog.open('SickLeaveCyclesInformationHelp', { 'employee_id': this.page.bindings.id }, {});
	}
}

class ReportSickLeaveCyclesPage
{
	constructor (bindings)
	{
		this.bindings = bindings;
		this.viewModel = new ReportSickLeaveCyclesViewModel(this);
	}

	async init()
	{
		// check access to page
		if (await Utils.redirectOnAccessDenied('EmployeeLeaveCycleInfoReport'))
			return;

		document.title = tr('Leave Cycles Information');
		window.current_page_title(tr('Leave Cycles Information'));

		let res = await Grape.fetches.getJSON('/api/record', {
			table: 'leave_category',
			schema: 'public',
			limit: 1000000
		});

		if (res)
			this.viewModel.categories(res.records);
	}

	updateData()
	{
		this.updateReportData();
	}

	async updateReportData()
	{
		let data = {
			department_id: this.viewModel.current_department_id(),
			category: this.viewModel.selected_category()
		};

		this.viewModel.leave_taken_full('');
		this.viewModel.loader(true);
		let res = await Grape.fetches.postJSON('/reports/next_leave_cycles', data);
		console.log('result', res);

		if (res)
		{
			if (res.status)
				this.viewModel.leave_taken_full('');
			else
				this.viewModel.leave_taken_full(res);

			this.viewModel.loader(false);
		}
	}
}

export default {
	route: '[/]report/sick_leave_cycles',
	page_class: ReportSickLeaveCyclesPage,
	template: template,
	template_filename: 'translation/report_sick_leave_cycles'
};
